import { getAvatarPhotoThunk } from '../../../store/workspace/thunks';
import { useSelector, useDispatch } from '../../../store/store';
import { setSideBarShow } from '../../../store/workspace/slice';
import { selectUserId } from '../../../store/auth/selectors';
import { useNavigate } from 'react-router-dom';
import styles from './style.module.scss';
import { useEffect } from 'react';
import {
    HambergurIcon,
    TypographyLogo,
} from '../../../assets/icons/common';
import {
    selectAvatarPhoto,
    selectSideBarShow,
    selectUserAttributes,
} from '../../../store/workspace/selectors';

function Header() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const userId = useSelector(selectUserId);
    const avatar = useSelector(selectAvatarPhoto);
    const sideBarShow = useSelector(selectSideBarShow);
    const userAttributes = useSelector(selectUserAttributes);

    useEffect(() => {
        if (!avatar && userId) {
            dispatch(getAvatarPhotoThunk(`${userId}/avatar.png`));
        }
    }, [avatar, userId]);

    return (
        <div className={styles.container}>
            <HambergurIcon
                className={styles.hambergur}
                onClick={() => dispatch(setSideBarShow(!sideBarShow))}
            />
            <TypographyLogo
                width={145}
                height={36}
                className={styles.logo}
                onClick={() => navigate('/')}
            />
            <div className={styles.profile}>
                {/* <div className={styles.profile_notification}>
                    <span></span>
                </div> */}

                <div
                    className={styles.profile_avatar}
                    onClick={() => navigate('/workspace/account')}
                >
                    {avatar ? <img
                        src={avatar}
                        alt="avatar"
                    /> : <span>{userAttributes?.given_name?.slice(0, 1)}</span>}
                </div>
            </div>
        </div>
    );
};

export default Header;